import { styled } from "dripsy";
import { SafeAreaView as SAV } from "react-native-safe-area-context";

const SafeAreaView = styled(SAV)();

export default SafeAreaView;
